import Model, { attr, belongsTo } from '@ember-data/model';
import type { Type } from '@warp-drive/core-types/symbols';

import type QuestionnaireField from './questionnaire-field';
import type QuestionnaireResponse from './questionnaire-response';

export default class QuestionnaireFieldResponse extends Model {
  declare [Type]: 'questionnaire-field-response';

  @belongsTo('questionnaire-response', { async: false, inverse: 'questionnaireFieldResponses' })
  declare questionnaireResponse: QuestionnaireResponse;

  @belongsTo('questionnaire-field', { async: false, inverse: null })
  declare questionnaireField: QuestionnaireField;

  @attr('boolean') declare isCorrect: boolean;
  @attr('array') declare selectedOptionIds: string[];
}
